import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ProgramsTable from "./table";
import Pagination from "../common/pagination";
import { getPrograms, deleteProgram } from "../../services/programService";
import { paginate } from "../../utils/paginate";
import _ from "lodash";
import SearchBox from "../searchBox";

class Programs extends Component {
  state = {
    programs: [],
    currentPage: 1,
    pageSize: 4,
    searchQuery: "",
    sortColumn: { path: "name", order: "asc" },
  };

  async componentDidMount() {
    const { data } = await getPrograms();
    this.setState({ programs: data.programs });
  }

  handleDelete = async (program) => {
    const originalPrograms = this.state.programs;
    const programs = originalPrograms.filter((m) => m._id !== program._id);
    this.setState({ programs });

    try {
      await deleteProgram(program._id);
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error("This program has already been deleted.");

      this.setState({ programs: originalPrograms });
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSearch = (query) => {
    this.setState({ searchQuery: query, currentPage: 1 });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      sortColumn,
      searchQuery,
      programs,
    } = this.state;

    let allPrograms = programs;
    let filtered = allPrograms;
    // console.log(filtered)
    if (searchQuery)
      filtered = allPrograms.filter((m) =>
        m.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    // console.log(filtered)
    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const data = paginate(sorted, currentPage, pageSize);
    // console.log(filtered, filtered.length)
    return { totalCount: filtered.length, data };
  };

  render() {
    const { length: count } = this.state.programs;
    const { pageSize, currentPage, sortColumn, searchQuery } = this.state;

    const { totalCount, data: programs } = this.getPagedData();
    // console.log(totalCount)
    // console.log(programs)

    return (
      <div className="row">
        <div className="col">
          <Link
            to="/programs/new"
            className="btn btn-primary float-right mt-4"
            style={{ marginBottom: 20 }}
          >
            Nuevo programa
          </Link>

          {count !== 0 && (
            <React.Fragment>
              <SearchBox value={searchQuery} onChange={this.handleSearch} />
              <p>Mostrando {totalCount} registros.</p>
              <ProgramsTable
                programs={programs}
                sortColumn={sortColumn}
                onDelete={this.handleDelete}
                onSort={this.handleSort}
              />
              <Pagination
                itemsCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPage}
                onPageChange={this.handlePageChange}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default Programs;
